import { render, staticRenderFns } from "./tournament-registration.vue?vue&type=template&id=32bc0eec&scoped=true&"
import script from "./tournament-registration.vue?vue&type=script&lang=js&"
export * from "./tournament-registration.vue?vue&type=script&lang=js&"
import style0 from "./tournament-registration.vue?vue&type=style&index=0&id=32bc0eec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bc0eec",
  null
  
)

export default component.exports